import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, PLATFORM_ID, APP_ID, Inject, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
//import { HttpModule } from '@angular/common/http';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { BrowserAnimationsModule }
    from '@angular/platform-browser/animations';

/*Shared service and component*/
import { SharedServiceModule } from './shared-service/shared-service.module';
import { SharedComponentModule } from './shared-components/shared-components.module';


/*App basic components*/
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './page-not-found/not-found.component';
import { FooterComponent } from './footer/footer.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

/*Login Component*/
import { LoginComponent } from './login/login.component';
import { LoginService } from './login/login.service';

/*Parent module specific routing*/
import { AppRoutingModule } from './app-routing.module';

/*Learner Component*/
import { MainContainerComponent } from './learner/main-container.component';
import { NavbarComponent } from './learner/navbar/navbar.component';
import { NavbarService } from './learner/navbar/navbar.service';


import { SystemAlertModule } from './learner/system-alert/system-alert.module';

//import { importExpr } from '@angular/compiler/src/output/output_ast';
import { CustomerCareModule } from './learner/customer-care/customer-care.module';

import { NotificationComponent } from './learner/notification/notification.component';
import { AnnouncementComponent } from './learner/notification/announcement/announcement.component';
import { AnnouncementDetailComponent } from './learner/notification/announcement-detail/announcement-detail.component';

import { ItemNotificationComponent } from './learner/notification/item-notification/item-notification.component';
import { LeaderboardModule } from './learner/leaderboard/leaderboard.module';

import { BaseService } from './shared-service/base.service';
import { SystemAlertService } from './learner/system-alert/system-alert.service';
import { ExternalLearningComponent } from './learner/external-learning/external-learning.component';

import {FontboxComponent} from './learner/fontbox/fontbox.component';
import { GlobalSearchComponent } from './learner/global-search/global-search.component';
import { DeeplinkComponent } from './deeplink/deeplink.component';
import { DeeplinkService } from './deeplink/deeplink.service';
import { OverviewModule } from './learner/overview/overview.module';
import { AppHttpInterceptor } from './shared-service/app-httpinterceptor';
import { DataService } from './shared-service/data.service';
import { AuthModule } from './auth/auth.module';
import { AuthGuard } from './auth/auth.gaurd';
import { AppService } from './app.service';
import { WindowRef } from './shared-service/windowRef.service';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PageNotFoundComponent,
    FooterComponent,
    MainContainerComponent,
    NavbarComponent,
    UnauthorizedComponent,
    NotificationComponent,
    AnnouncementComponent,
    AnnouncementDetailComponent,
    ItemNotificationComponent,
    FontboxComponent,
    GlobalSearchComponent,
    DeeplinkComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    //HttpModule,
    HttpClientModule,
    SharedServiceModule.forRoot(),
    SharedComponentModule,
    OverviewModule,
    AuthModule,
    CommonModule,
    BrowserAnimationsModule
    //FormsModule,
    //ReactiveFormsModule,
    // KeycloakAngularModule
  ],
  providers: [
    AppService,
    LoginService, 
    NavbarService, 
    BaseService, 
    SystemAlertService, 
    Title, 
    DeeplinkService, 
    DataService,
    { 
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true
    },
    AuthGuard,
    WindowRef
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})

export class AppModule {
  constructor( @Inject(PLATFORM_ID) private platformId: Object, @Inject(APP_ID) private appId: string,private bs:BaseService) {
    this.bs.log('info',"Loaded AppModule");
    const platform = isPlatformBrowser(platformId) ? 'on the server' : 'in the browser';
    this.bs.log('info',`Running ${platform} with appId=${appId}`);
  }
}
